module.exports = "/lucky-balls/img/drum/drum_loop_027.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_027.png
// module id = 1042
// module chunks = 0